import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Academics from './Academics';
import CollegeCoachActivity from '../CollegeCoachActivity';
import MyTargetColleges from './MyTargetColleges';
import PrimaryContact from './PrimaryContact';
import { getPlayerStudentInfo } from '../../../actions/profile-actions';
import styles from './collegeProspectTab.scss';

const CollegeProspectTab = () => {
    const dispatch = useDispatch();
    const claimedPlayerId = useSelector((state) => state.auth?.user?.claimedPlayer?.playerId);
    const profilePlayerId = useSelector((state) => state.profile?.data?.id);
    const hasStudentInfo = useSelector((state) => Boolean(state.profile?.data?.studentInfo));

    const [targetCollegesRefreshKey, setTargetCollegesRefreshKey] = useState(0);

    const handleTargetCollegesAdded = () => {
        setTargetCollegesRefreshKey(prev => prev + 1);
    };

    const playerId = profilePlayerId || claimedPlayerId;

    useEffect(() => {
        if (!hasStudentInfo && playerId) {
            dispatch(getPlayerStudentInfo(playerId));
        }
    }, [dispatch, hasStudentInfo, playerId]);

    return (
        <div className={`tab-content ${styles.collegeProspectTabContent}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <MyTargetColleges refreshKey={targetCollegesRefreshKey} />
                        <CollegeCoachActivity onAddSuccess={handleTargetCollegesAdded} />
                    </div>
                    <div className="col-12 col-lg-4">
                        <Academics />
                        <PrimaryContact />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollegeProspectTab;
